module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meeting"
  }, [_c('h4', {
    staticClass: "meeting__number"
  }, [_vm._v("Встреча " + _vm._s(_vm.meetingNumber))]), _c('div', {
    staticClass: "meeting__grid"
  }, [_c('MentoringMeetingDate', {
    attrs: {
      "date": _vm.meeting.date
    }
  }), _c('MentoringTimeMeeting', {
    attrs: {
      "time": _vm.meeting.time,
      "address": _vm.meeting.address
    }
  }), _c('MentoringMeetingStatus', {
    attrs: {
      "type": "Тип",
      "status": _vm.meeting.type
    }
  }), _c('MentoringMeetingStatus', {
    attrs: {
      "type": "Формат",
      "status": _vm.meeting.format
    }
  })], 1), _c('MentoringMeetingStatus', {
    attrs: {
      "type": "Статус",
      "status": _vm.meeting.status
    }
  }), _c('MentoringMeetingResult'), _c('p', {
    staticClass: "meeting__result"
  }, [_vm._v(_vm._s(_vm.meeting.myResult))]), _c('div', {
    staticClass: "meeting__button"
  }, [_c('Button', {
    attrs: {
      "bordered": true,
      "autowidth": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Закрыть")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1de5a0b2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/MentoringMeeting.vue
// module id = c6b47d47227d5bfe46d5
// module chunks = 89